import { render, staticRenderFns } from "./Filiales.vue?vue&type=template&id=bcb354c8"
import script from "./Filiales.vue?vue&type=script&lang=js"
export * from "./Filiales.vue?vue&type=script&lang=js"
import style0 from "./Filiales.vue?vue&type=style&index=0&id=bcb354c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports